import { render } from "./SignatureComponent.vue?vue&type=template&id=24995a21&scoped=true"
import script from "./SignatureComponent.vue?vue&type=script&lang=js"
export * from "./SignatureComponent.vue?vue&type=script&lang=js"

import "./SignatureComponent.vue?vue&type=style&index=0&id=24995a21&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24995a21"]])

export default __exports__